import angular from "angular";

angular.module('ui-sentinel.shipments.shipmentNew', [
    'api-sentinel'
]);
